import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Tooltip from '../tooltip/tooltip';
import compose from '../../hoc/compose';
import TextLabel from '../textLabel/textLabel';
import Button from '../button/button';

var ActionsListItem = /*#__PURE__*/function (_React$Component) {
  _inherits(ActionsListItem, _React$Component);

  var _super = _createSuper(ActionsListItem);

  function ActionsListItem() {
    var _this;

    _classCallCheck(this, ActionsListItem);

    _this = _super.call(this);

    _this.getTextWidth = function () {
      return "calc(100% - ".concat(!_.isEmpty(_this.props.contentBefore) * 96 + !_.isEmpty(_this.props.contentAfter) * 24, "px)");
    };

    return _this;
  }

  _createClass(ActionsListItem, [{
    key: "getPrimaryAction",
    value: function getPrimaryAction() {
      var PrimaryAction = /*#__PURE__*/React.createElement("div", {
        key: "primaryAction",
        "data-aid": "primary-action",
        className: "list-item-primary-action ".concat(this.props.primaryActionData.symbol && 'symbol-item'),
        onClick: this.props.primaryActionData.onClick
      }, this.props.primaryActionData.symbol ? this.props.primaryActionData.symbol : /*#__PURE__*/React.createElement(Button, {
        className: "btn-md"
      }, this.props.primaryActionData.label));

      if (this.props.primaryActionData.tooltipText) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          content: this.props.primaryActionData.tooltipText
        }, PrimaryAction);
      }

      return PrimaryAction;
    }
  }, {
    key: "getSecondaryAction",
    value: function getSecondaryAction() {
      var SecondaryAction = /*#__PURE__*/React.createElement("div", {
        onClick: this.props.secondaryActionData.onClick,
        "data-aid": "secondary-action-icon",
        className: "secondary-action-icon"
      }, this.props.secondaryActionData.symbol);

      if (this.props.secondaryActionData.tooltipText) {
        return /*#__PURE__*/React.createElement(Tooltip, {
          content: this.props.secondaryActionData.tooltipText
        }, SecondaryAction);
      }

      return SecondaryAction;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "control-actions-list-item ".concat(this.props.className)
      }, this.props.iconData ? /*#__PURE__*/React.createElement("div", {
        key: "iconBefore",
        "data-aid": "icon-before",
        className: "list-item-icon-before ".concat(this.props.iconData.type || '')
      }, this.props.iconData.symbol) : null, /*#__PURE__*/React.createElement("div", {
        className: "list-item-text",
        style: {
          width: this.getTextWidth()
        }
      }, /*#__PURE__*/React.createElement(TextLabel, {
        className: "list-item-label",
        type: "T02",
        value: this.props.label,
        shouldTranslate: this.props.shouldTranslate,
        automationId: "text-label"
      })), this.props.primaryActionData && this.getPrimaryAction(), this.props.secondaryActionData && this.getSecondaryAction());
    }
  }]);

  return ActionsListItem;
}(React.Component);

ActionsListItem.displayName = 'ActionsListItem';
ActionsListItem.propTypes = {
  /** Primary Action */
  primaryActionData: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    symbol: PropTypes.element,
    tooltipText: PropTypes.string
  }).isRequired,

  /** The main title for the item */
  label: PropTypes.string.isRequired,

  /** Secondary Action */
  secondaryActionData: PropTypes.shape({
    onClick: PropTypes.func,
    symbol: PropTypes.element,
    tooltipText: PropTypes.string
  }),

  /** Icon Data **/
  iconData: PropTypes.shape({
    symbol: PropTypes.element,
    type: PropTypes.string
  }),

  /** Class Name **/
  className: PropTypes.string
};
export default compose(ActionsListItem);